import { buildI18nInjectionToken } from '@pct-ng/transloco';

const I18nScope = 'ng/feature/table/material';
export const I18nProviderInjectionToken = buildI18nInjectionToken(I18nScope);
